import React from "react";
import { Button } from "antd";
import { useHistory } from "react-router-dom";

const GoBackButton = () => {
    const history = useHistory();
    return (
        <Button onClick={() => history.goBack()} icon="rollback" size={"small"}>
            返回
        </Button>
    );
};

export default GoBackButton;
